module.exports = __webpack_public_path__ + "static/img/12.d035e9f0.png";